import { Box } from "@mui/material";
import { format } from "date-fns";
import { t } from "i18next";
import { useEffect, useState } from "react";
import BaseTable from "../../../../components/table/BaseTable";
import { useAgreements } from "../../../../services/agreementsService";
import { useLocalizedProperty } from "../../../../utils";
import { AgreementPassportButton } from "../../../AgreementsPage/AgreementPassportDialog/AgreementPassportButton";
import { AgreementStatusText } from "../../../AgreementsPage/AgreementStatusText";
import InfoIcon from "@mui/icons-material/Info";
import FiaskoEditDialog from "../../../../components/dialog/FiaskoEditDialog/FiaskoEditDialog";
import { useDialogBetter } from "../../../../hooks/useDialogBetter";

const HEADERS = [
    // t("clients.ClientPassportAgreementTable.agreementNumber"),
    t("clients.ClientPassportAgreementTable.agreementKind"),
    t("clients.ClientPassportAgreementTable.dateCreated"),
    t("clients.ClientPassportAgreementTable.investmentName"),
    t("clients.ClientPassportAgreementTable.productNames"),
    t("clients.ClientPassportAgreementTable.status"),
    "",
];

export function ClientPassportAgreementsTable(props) {
    const params = new URLSearchParams();
    params.set("customer_id", props.customerId);
    if (props.investmentId) {
        params.set("investment", props.investmentId);
    }

    const { openDialog: openFiaskoDialog } = useDialogBetter();
    const handleOpenFiaskoDialog = (agreementId, reasonId, reasonNote) => {
        openFiaskoDialog({
          Component: FiaskoEditDialog,
          componentProps: {
            agreementId: agreementId,
            reasonNote: reasonNote,
            reasonId: reasonId,
          },
        });
    };

    const getLocalizedProperty = useLocalizedProperty();

    const { data: agreementsData, isLoading } = useAgreements(params);
    const [processedAgreements, setProcessedAgreements] = useState([]);

    useEffect(() => {
        const processAgreements = async () => {
            if (agreementsData?.results) {
                const processed = agreementsData.results.map((agreement) => {
                    const productNames = agreement.products
                        .map((p) => p.product.name_full)
                        .join("\n");
                    const investmentName =
                        agreement.products.length > 0
                            ? agreement.products[0].product.investment.investment_name_sales
                            : "-";

                    return {
                        rowId: agreement.id,
                        data: [
                            // agreement.agreement_nr,
                            getLocalizedProperty(agreement.agreement_kind, "agrekind_name"),
                            format(new Date(agreement.created), "yyyy-MM-dd"),
                            investmentName,
                            productNames,
                            agreement.agreement_status?.status_key === "agreementCancelled" ? (
                            <div style={{display: "flex", justifyContent: "center"}}> 
                                <AgreementStatusText
                                status={agreement.agreement_status}
                            />
                                <InfoIcon style={{cursor: "pointer", marginLeft: "5px"}} onClick={()=>handleOpenFiaskoDialog(agreement.id, agreement.agreement_status_reason?.id, agreement.agreement_status_note)}/>
                            </div>) : (
                                <AgreementStatusText status={agreement.agreement_status} />
                            ),
                            <AgreementPassportButton agreement={agreement} />,
                        ],
                    };
                });
                setProcessedAgreements(processed);
            }
        };

        processAgreements();
    }, [agreementsData]);

    return (
        <Box sx={{ maxHeight: props.maxHeight || 200, overflow: "auto", borderRadius: 1 }}>
            <BaseTable
                stickyHeader={true}
                headers={HEADERS}
                rows={processedAgreements}
                showEditButton={false}
                showDeleteButton={false}
                sortable={false}
                hiddenColumns={[]}
                selectedRows={[]}
                showLoader={isLoading}
                colMaxLength={props.colMaxLength}
            />
        </Box>
    );
}
